import { TContactID } from "../Types/TContactID";
import { IConversation } from "../Types/IConversation";

export const Conversations: IConversation[] = [
    {
        scriptId: "IntroConversation",
        participants: ["TestContact1"],
        dayRange: [0, Number.MAX_SAFE_INTEGER],
    },
];